import ApproverState from '@/models/ApprovalInstance/ApproverState';

export default class ApproverStateFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.approvalInstanceId  = '';
		this.approvalInstanceApprovalTag = '';
		this.approverTypeId  = '';
		this.approverTypeName = '';
		this.approvalStructureId  = '';
		this.approvalStructureName = '';
		this.approverLevel = '';
		this.approverUserId  = '';
		this.approverUserFirstName = '';
		this.activityStateId  = '';
		this.activityStateName = '';
		this.approvalConfigurationInstanceDetailId  = '';
		this.approvalConfigurationInstanceDetailApproverType = '';
		this.sequence = '';
		this.storedProcedureName = '';
		this.isSendNotification = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			approvalInstanceId : '0',
			approvalInstanceApprovalTag : '0',
			approverTypeId : '0',
			approverTypeName : '0',
			approvalStructureId : '0',
			approvalStructureName : '0',
			approverLevel : '0',
			approverUserId : '0',
			approverUserFirstName : '0',
			activityStateId : '0',
			activityStateName : '0',
			approvalConfigurationInstanceDetailId : '0',
			approvalConfigurationInstanceDetailApproverType : '0',
			sequence : '0',
			storedProcedureName : '0',
			isSendNotification : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}